import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const HTTP_URL_PREFIX_PATTERN = /^https?:\/\//i;
const URL_WHITESPACE_PATTERN = /\s/;
const MALFORMED_PERCENT_ENCODING_PATTERN = /%(?![0-9a-f]{2})/i;

export const httpUrlValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

  if (control.value === null || control.value === undefined || control.value === '') {
    return null;
  }

  if (typeof control.value !== 'string') {
    return { invalidUrl: true };
  }

  const urlValue = control.value.trim();
  if (!urlValue) {
    return { invalidUrl: true };
  }

  if (
    !HTTP_URL_PREFIX_PATTERN.test(urlValue) ||
    URL_WHITESPACE_PATTERN.test(urlValue) ||
    MALFORMED_PERCENT_ENCODING_PATTERN.test(urlValue)
  ) {
    return { invalidUrl: true };
  }

  try {
    const parsedUrl = new URL(urlValue);
    const hasSupportedProtocol =
      parsedUrl.protocol === 'http:' ||
      parsedUrl.protocol === 'https:';

    if (!hasSupportedProtocol || !parsedUrl.hostname) {
      return { invalidUrl: true };
    }

    return null;
  } catch {
    return { invalidUrl: true };
  }
};
